/** One factory for every query key, so invalidation is a one-liner and typos can't drift apart. */
export const queryKeys = {
  version: ['version'] as const,
  memberships: ['memberships'] as const,

  condo: (condoId: number) => ['condo', condoId] as const,
  units: (condoId: number) => ['units', condoId] as const,

  posts: {
    pending: (condoId: number) => ['posts', condoId, 'pending'] as const,
    reported: (condoId: number) => ['posts', condoId, 'reported'] as const,
  },
  polls: {
    pending: (condoId: number) => ['polls', condoId, 'pending'] as const,
    reported: (condoId: number) => ['polls', condoId, 'reported'] as const,
  },

  bookings: (condoId: number, status?: string) => ['bookings', condoId, status ?? 'all'] as const,

  desk: {
    list: (condoId: number, status: 'waiting' | 'done') => ['desk', condoId, status] as const,
    expected: (condoId: number, date: string) => ['desk', condoId, 'expected', date] as const,
    all: (condoId: number) => ['desk', condoId] as const,
  },

  people: (condoId: number, q: string) => ['people', condoId, q] as const,
  balances: (condoId: number) => ['balances', condoId] as const,
  team: (condoId: number) => ['team', condoId] as const,
  scopeCapabilities: (condoId: number) => ['scope-capabilities', condoId] as const,
}
